import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
import ViewpointFields from './formGroup12ViewpointFields';

export default {
  title: 'Cameras',
  attributeName: 'cameras',
  validationUrl:'live',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      required: true,
      helpText: 'Set the Name.',
      errorText: '',
    },
    {
      attributeName: 'viewPoint',
      type: FormInputTypes.JSON_COMPONENT,
      emptyMessage: "You don't have any view point yet.",
      columns:1,
      canCreate:false,
      canRemove:false,
      label: 'View points',
      itemLabel:'View point',
      required: true,
      helpText: 'Insert new view points clicking in + button.',
      errorText: '',
      extraValues:['deploymentType'],
      popupFormGroups:[
        ViewpointFields

      ]
    },
    // {
    //   attributeName: 'streams',
    //   type: FormInputTypes.JSON_COMPONENT,
    //   emptyMessage: "You don't have any stream yet.",
    //   columns:4,
    //   label: 'Streams',
    //   itemLabel:'Stream',
    //   required: true,
    //   helpText: 'Insert new streams clicking in + button.',
    //   errorText: '',
    //   popupFormGroups:[
    //     StreamFields

    //   ]
    // },
  ]
};
